import "./HowItWorks.module.css";
import Header from "@/reusable_sections/Header";
import Roadmap from "./sections/Roadmap";
import Methodology from "./sections/Methodology";
import Milestones from "./sections/Milestones";
import Footer from "@/reusable_sections/Footer";
export default function HowItWorksPage() {
  return <div>
      <Header />
      <Roadmap />
      <Methodology />
      <Milestones />
      <Footer />
    </div>;
}